import { PropsWithChildren } from "react";
import PageContent from "./PageContent";
import { ITitleI18nConf } from ".";
export default function AndroidPageContent({ children, titleConf, reload }: {titleConf?:ITitleI18nConf, reload?: boolean} & PropsWithChildren)  {
    return (
        <PageContent titleConf={titleConf} reload={reload}>
            {children}
        </PageContent>
    )
}
